import { bl_del_job_checklist_line_RowClass, bl_del_job_checklist_line_RowInterface } from '../../../../dbschema';
import { BaseContainerModel } from '../../../base-container.model';

export class JobCheckListLineContainerModel extends BaseContainerModel {
  bl_del_job_checklist_line: bl_del_job_checklist_line_RowInterface = new bl_del_job_checklist_line_RowClass();
}